import React, {Fragment} from 'react';
import {Table, PaginationProps, TableProps} from 'antd';
type Props = {
  columns: Array<any>;
  dataSource: Array<any> | undefined;
  pagination?: PaginationProps | false;
  loading?: boolean;
  border?: boolean;
  handleTableChange?: Function;
  rowKey?: any;
  rowSelection?: any;
  onRow?: any;
  components?: any;
  tableProps?: TableProps<any>;
};

const DataTable = ({
  columns,
  dataSource,
  loading,
  handleTableChange,
  pagination,
  border,
  rowKey,
  rowSelection,
  onRow,
  components,
  tableProps,
}: Props) => {
  return (
    <Fragment>
      <Table
        components={components}
        columns={columns}
        rowSelection={rowSelection}
        dataSource={dataSource}
        rowKey={rowKey}
        pagination={pagination}
        onRow={onRow}
        loading={loading}
        bordered={border}
        scroll={{
          x: true,
        }}
        onChange={handleTableChange ? () => handleTableChange : undefined}
        {...tableProps}
      />
    </Fragment>
  );
};

export default DataTable;
